import { Grid2, TextField } from "@mui/material";
import { TextFieldStyles } from "../../../styles/commonStyles";
import { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";
import { toolsValidationSchema } from "../../../validation/schemas/toolsSchema";
import { PLACEHOLDERS } from "../../../constants/placeholders";

const UpdateGatewayForm = ({ onFormDataChange, control, errors }) => {
  const watchedValues = useWatch({ control });

  useEffect(() => {
    if (onFormDataChange && watchedValues) {
      onFormDataChange(watchedValues);
    }
  }, [watchedValues, onFormDataChange]);

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="nickname"
          control={control}
          rules={toolsValidationSchema.gatewayName}
          render={({ field }) => (
            <TextField
              {...field}
              variant="filled"
              label="Nome"
              sx={{ ...TextFieldStyles }}
              fullWidth
              error={!!errors.nickname}
              helperText={errors.nickname?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Controller
          name="devEUI"
          control={control}
          rules={toolsValidationSchema.gatewayEui}
          render={({ field }) => (
            <TextField
              {...field}
              variant="filled"
              label="EUI"
              sx={{ ...TextFieldStyles }}
              fullWidth
              error={!!errors.devEUI}
              helperText={errors.devEUI?.message}
              placeholder={PLACEHOLDERS.TOOLS.GATEWAY_EUI}
              disabled
            />
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default UpdateGatewayForm;
